import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  setFilterDropdownShow,
  setFilterValue,
  setFormControlShow,
} from '../../redux/actions/newFilter';

import NewFilter from './NewFilter.component';

const mapStateToProps = state => ({
  filterDropdownShow: state.newFilter.filterDropdownShow,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = {
  setFilterDropdownShow,
  setFilterValue,
  setFormControlShow,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NewFilter));
